export default {"src":"https://search.prod.wiggot.com/_next/static/media/wiggot-logo.08a9ae45.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};